import { produce } from "immer";
import { modules } from "../../constants";
import { initialFooterDisabledState, breakdownTabs } from ".";
import { listingViews } from "../../market-dynamics/constants/listingViews";
import { periodKeys } from '../../market-dynamics/constants';

export const actions = (set, get) => ({
    setMDListingViewId: listingViewId => set(produce(state => {
        const selectedModule = get().selectedModule;
        if (selectedModule !== modules.marketDynamics.marketDynamics) return;
        const moduleState = state[selectedModule];
        moduleState.listingViewId = listingViewId;
    }), false, 'setMarketDynamicsListingViewId'),
    setIsFooterDisabled: (tabIndex, isFooterDisabled, pathname) =>
        get().setBreakdownTabs([{[tabIndex]: { isFooterDisabled }}], pathname),
    setTabListingStatus: (tabIndex, listingStatus, pathname)  =>
        get().setBreakdownTabs([{[tabIndex]: { listingStatus }}], pathname),
    resetDisabledFooterTabs: pathname =>
        get().setBreakdownTabs([{
            [breakdownTabs.OFFICE]: initialFooterDisabledState,
            [breakdownTabs.LISTING_1]: initialFooterDisabledState,
            [breakdownTabs.LISTING_2]: initialFooterDisabledState,
            [breakdownTabs.LISTING_3]: initialFooterDisabledState,
        }], pathname),
    setMDListingStatusByView: (listingViewId, options) =>
        set(produce(state => {
            const selectedModule = get().selectedModule;
            if (selectedModule !== modules.marketDynamics.marketDynamics) return;
            const moduleState = state[modules.marketDynamics.marketDynamics];
            if (!moduleState.listingStatusByView) moduleState.listingStatusByView = {};
            moduleState.listingStatusByView[listingViewId] = options.map(({ id, checked }) => ({ id, checked }));
        }), false, 'setMDListingStatusByView'),
    clearMDSortByView: (listingViewId) => set(produce(state => {
        const selectedModule = get().selectedModule;
        if (!state[selectedModule]?.retainedSortStateByView) return;
        delete state[selectedModule].retainedSortStateByView[listingViewId];
    }), false, 'clearMDSortByView'),
    resetMDPersistedData: () => set(produce(state => {
        if (get().selectedModule !== modules.marketDynamics.marketDynamics) return;
        const moduleState = state[get().selectedModule];
        if (moduleState.listingViewId) moduleState.listingViewId = listingViews.overview.value;
        moduleState.chartFilters = { selectedPeriodComparison: periodKeys.beginVsEndMonth };
        moduleState.listingStatusByView = {};
        get().resetBreakdowns();
    })),
    mergeStoredOptionsWithDefaults: (defaultOptions, storedOptions) => {
        return defaultOptions.map(defaultOption => {
            const storedOption = storedOptions.find(stored => stored.id === defaultOption.id);
            return {
                ...defaultOption,
                checked: storedOption ? storedOption.checked : defaultOption.checked || false
            };
        });
    },
    setMDChartFilters: ({ selectedPeriodComparison, selectedBeginValue, selectedEndValue }) =>
        set(produce(state => {
            const moduleState = state[modules.marketDynamics.marketDynamics];
            if (!moduleState.chartFilters) moduleState.chartFilters = {};
            if (selectedEndValue !== undefined) moduleState.chartFilters.selectedEndValue = selectedEndValue;
            if (selectedPeriodComparison !== undefined) moduleState.chartFilters.selectedPeriodComparison = selectedPeriodComparison;
            if (selectedBeginValue !== undefined) moduleState.chartFilters.selectedBeginValue = selectedBeginValue;
        }), false, 'setMDChartFilters'),
});
